import axios from 'axios';

import routes from 'app/routes';

export default {
  selectMembers: (dispatch, memberIds) => {
    dispatch({ type: 'SELECT_MEMBERS', memberIds });
  },

  assignProgram: ({ programId, memberIds, afterCallback = () => {} }) => {
    const params = {
      member_ids: memberIds,
    };

    axios
      .post(routes.api.managers.programs.assign(programId), params)
      .then((response) => {
        afterCallback(response);
      });
  },
};
